// QuizScale.js
import React, { useEffect, useState } from "react";
import IframeCSSContext from "./QuizIfameCSSContext";
import { Helmet } from "react-helmet";

const QuizIframeCSS = ({ children }) => {
  const [IframeCSSFactor, setIframeCSSFactor] = useState(false);
  const [addCSS, setAddCSS] = useState("");

  useEffect(() => {
    //check if it is iframe or not
    if (true) {
      //window.self !== window.top) {
      const params = new URLSearchParams(window.location.search);
      const iframeCSSParam = params.get("iframereset");
      const quizContainer = document.getElementById("quiz-container");
      const quizContainerOverview = document.getElementById("overview");
      const addCSS = ``;

      if (iframeCSSParam === "true") {
        const iframeCSS = parseFloat(iframeCSSParam);
        setIframeCSSFactor(iframeCSS);

        if (quizContainer) {
          quizContainer.style.padding = `0px`;
          quizContainer.style.boxSizing = `border-box`;
          // console.log("uitvoeren", quizContainerOverview);
          setAddCSS(`#overview > div:first-child > :is(h1, h2, h3, h4, h5, h6):first-child {
            margin-block-start: 0;
          }`);
        }
      } else {
        quizContainer.style.padding = `20px`;
        quizContainer.style.boxSizing = `border-box`;
      }
    }
  }, []);
  return (
    <>
      <Helmet>
        <style>{addCSS}</style>
      </Helmet>
      <IframeCSSContext.Provider value={IframeCSSFactor}>
        {children}
      </IframeCSSContext.Provider>
    </>
  );
};

export default QuizIframeCSS;
